import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchConsultants({ callbacks }) {
  try {
    const response = yield call(api.fetchConsultants);
    yield put(Actions.fetchConsultantsSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchConsultantsFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchConsultants() {
  yield takeLatest(Actions.FETCH_CONSULTANTS_REQUEST, fetchConsultants);
}

export default function* consultants() {
  yield all([fork(watchFetchConsultants)]);
}
